import React from "react";

/**
 * Marquee — alien/holographic variants (no flat gradients).
 *  - "holo":    dark bg, chrome shimmering text, scan-line overlay
 *  - "outline": dark bg, outlined display text in purple stroke
 *  - "glass":   glass morphism with bordered chips
 */
const Marquee = ({ items = [], variant = "holo", speed = "marquee", testId }) => {
  const repeated = [...items, ...items];

  const speedClass =
    speed === "marquee-slow" ? "animate-marquee-slow" :
    speed === "marquee-fast" ? "animate-marquee-fast" :
    speed === "marquee-reverse" ? "animate-marquee-reverse" :
    "animate-marquee";

  if (variant === "outline") {
    return (
      <div data-testid={testId || "marquee-outline"} className="overflow-hidden bg-brand-bg border-y border-brand-border py-6 relative scanlines">
        <div className={`flex whitespace-nowrap ${speedClass} marquee-track`}>
          {repeated.map((item, idx) => (
            <span key={idx} className="flex items-center px-6 font-heading text-[10vw] md:text-[8vw] font-black uppercase tracking-tighter text-outline">
              {item}
              <span className="mx-6 text-brand-pink text-3xl">◆</span>
            </span>
          ))}
        </div>
      </div>
    );
  }

  if (variant === "glass") {
    return (
      <div data-testid={testId || "marquee-glass"} className="overflow-hidden bg-brand-bg/60 backdrop-blur-xl border-y border-brand-border py-5 relative scanlines">
        <div className={`flex whitespace-nowrap ${speedClass} marquee-track`}>
          {repeated.map((item, idx) => (
            <span key={idx} className="flex items-center px-6 font-heading text-2xl md:text-3xl font-bold uppercase tracking-tight text-zinc-200">
              {item}
              <span className="mx-6 text-brand-purpleLight">◆</span>
            </span>
          ))}
        </div>
      </div>
    );
  }

  // holo default — dark bg with shimmering chrome text + scan lines
  return (
    <div data-testid={testId || "marquee-holo"} className="overflow-hidden bg-brand-bgSecond border-y border-brand-border py-6 relative scanlines">
      <div className={`flex whitespace-nowrap ${speedClass} marquee-track`}>
        {repeated.map((item, idx) => (
          <span key={idx} className="flex items-center px-6 font-heading text-3xl md:text-5xl font-black uppercase tracking-tighter text-white">
            {item}
            <span className="mx-6 text-brand-purpleLight text-2xl">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
